import React, { useEffect, useState, useRef } from 'react';
import { TableLayout } from '~components';
import { SupplierMaterialForm } from './supplier-material-form';
import SupplierMaterialFields from './fields-data';
import { Button, Popconfirm, message, Input } from 'antd';

import ApiServices from '~services';

const SupplierMaterial = () => {
  const defaultTabPanels = [
    {
      title: 'Detail',
      content: 'detail content',
    },
  ];
  const [loading, setLoading] = useState(false);
  const [isLoadingTab, setIsLoadingTab] = useState(false);
  const [selected, setSelected] = useState('');
  const [supplierMaterial, setSupplierMaterial] = useState([]);
  const [tabPanels, setTabPanels] = useState(defaultTabPanels);
  const [titleTab, setTitleTab] = useState('');
  const [fields, setFields] = useState({});
  console.log(fields);

  //-------------------------------------------------------------------
  const [searchTerm, setSearchTerm] = useState('');
  const typingTimeoutref = useRef(null);
  //-------------------------------------------------------------------
  const [searchByColumn, setSearchByColumn] = useState({
    code: '',
    name: '',
    address: '',
    phone: '',
    email: '',
    fax: '',
    representative: '',
    companyName: '',
  });

  const getSupplierMaterials = async () => {
    let dataFilterSend = { ...filter };
    if (Object.keys(dataFilterSend.Columns).length === 0) {
      delete dataFilterSend['Columns'];
    } else {
      const columnJSONSTRING = JSON.stringify(dataFilterSend.Columns);
      dataFilterSend.Columns = columnJSONSTRING;
    }

    try {
      setLoading(true);
      let { data } = await ApiServices.getSupplierMaterials(dataFilterSend);
      setLoading(false);
      let pag = pagination;
      pag.total = data?.totalRecords || 0;
      pag.pageSize = data?.pageSize;
      pag.current = data?.pageNumber;

      data = data?.data || [];
      setSupplierMaterial(data);
      setPagination(pag);
    } catch (error) {
      console.log('Error - getSupplierMaterials', error);
      console.error(error);
    }
  };

  useEffect(() => {
    getSupplierMaterials();
  }, []);

  //----------- Start ----- Pagination Search ---------
  //----------- Pagination --------------------------
  const onChangePagination = (page, size) => {
    let filterTemp = filter;
    filterTemp.PageNumber = page;
    filterTemp.PageSize = size;
    setFilter(filterTemp);
    getSupplierMaterials();
  };
  const [pagination, setPagination] = useState({
    total: 1,
    showSizeChanger: true,
    onChange: onChangePagination,
  });
  const [filter, setFilter] = useState({
    PageNumber: 1,
    PageSize: 20,
    Text: '',
    Columns: '',
  });

  // ------------ Search Text ------------------------
  const handleSearchTermChange = (e) => {
    const val = e.target.value;
    setSearchTerm(val);
    const filterTmp = filter;
    filterTmp.Text = val;

    if (typingTimeoutref.current) {
      clearTimeout(typingTimeoutref.current);
    }

    typingTimeoutref.current = setTimeout(() => {
      if (val.length > 2) {
        filter.PageNumber = 1;
        setFilter({ ...filterTmp, PageNumber: 1 });
        getSupplierMaterials();
      }
      if (val.length === 0) {
        setFilter({ ...filterTmp, PageNumber: 1 });
        getSupplierMaterials();
      }
    }, 1000);
  };
  // ------------ Search Column ----------------------
  const handleSearchColumnFn = (event, name) => {
    const filterTmp = filter;
    const val = event.target.value;
    let _searchByColumn = { ...searchByColumn };
    _searchByColumn[`${name}`] = val;
    setSearchByColumn(_searchByColumn);
    // Clear timeout
    if (typingTimeoutref.current) {
      clearTimeout(typingTimeoutref.current);
    }
    typingTimeoutref.current = setTimeout(() => {
      if (val.length > 0) {
        filter.PageNumber = 1;
        let searchColumnFn = { ...filter.Columns };
        searchColumnFn[`${name}`] = val;
        filter.Columns = searchColumnFn;

        setFilter({ ...filterTmp, PageNumber: 1 });
        getSupplierMaterials();
      }
      if (val.length === 0) {
        delete filter.Columns[`${name}`];
        setFilter({ ...filterTmp, PageNumber: 1 });
        getSupplierMaterials();
      }
    }, 1000);
  };
  // ------------- End Search --------------------

  const setFieldsForm = async (value) => {
    const supplierMaterialFields = await SupplierMaterialFields(value);
    await setFields(supplierMaterialFields);
    return supplierMaterialFields;
  };
  const reload = async () => {
    setSelected(null);
    await getSupplierMaterials();
  };

  const getUpdatedSupplierMaterialForm = async (value, isNew = false, id = null, dataSelected) => {
    const supplierMaterialForm = await (
      <SupplierMaterialForm
        fields={value}
        setLoading={setIsLoadingTab}
        isNew={isNew}
        id={id}
        reload={reload}
        onChange={setFields}
        dataSelected={dataSelected}
      />
    );
    return setTabPanels([
      {
        title: 'Thông Tin Chi Tiết',
        content: supplierMaterialForm,
      },
    ]);
  };

  const onRowSelected = async (value) => {
    await setIsLoadingTab(true);
    await setTitleTab(value.code);
    await setFieldsForm(value)
      .then((res) => {
        return getUpdatedSupplierMaterialForm(res, false, value.id, value);
      })
      .then(() => setSelected(value));
    setIsLoadingTab(false);
  };
  const deletedSupplierMaterial = async (record) => {
    try {
      const res = await ApiServices.deleteSupplierMaterial(record.id);
      if (res.data) {
        message.success('Xoá NCC thành công');
        return reload();
      }
      message.error('Xoá NCC thất bại, vui lòng thử lại sau!');
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Mã</div>
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.code}
            onChange={(event) => handleSearchColumnFn(event, 'code')}
          />
        </span>
      ),
      dataIndex: 'code',
      align: 'center',
      width: 150,
      render: (value, record) => (
        <a onClick={() => onRowSelected(record)}>{value || 'underFine'}</a>
      ),
    },
    {
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Tên NCC</div>
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.name}
            onChange={(event) => handleSearchColumnFn(event, 'name')}
          />
        </span>
      ),
      width: 200,
      align: 'center',
      dataIndex: 'name',
    },
    {
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Địa Chỉ</div>
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.address}
            onChange={(event) => handleSearchColumnFn(event, 'address')}
          />
        </span>
      ),
      width: 270,
      align: 'center',
      dataIndex: 'address',
    },
    {
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Điện Thoại</div>
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.phone}
            onChange={(event) => handleSearchColumnFn(event, 'phone')}
          />
        </span>
      ),
      width: 120,
      align: 'center',
      dataIndex: 'phone',
    },
    {
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Email</div>
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.email}
            onChange={(event) => handleSearchColumnFn(event, 'email')}
          />
        </span>
      ),
      width: 120,
      align: 'center',
      dataIndex: 'email',
    },
    {
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Fax</div>
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.fax}
            onChange={(event) => handleSearchColumnFn(event, 'fax')}
          />
        </span>
      ),
      dataIndex: 'fax',
      width: 120,
      align: 'center',
    },
    {
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Người Đại Diện</div>
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.representative}
            onChange={(event) => handleSearchColumnFn(event, 'representative')}
          />
        </span>
      ),
      width: 140,
      align: 'center',
      dataIndex: 'representative',
    },
    {
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Công Ty</div>
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.companyName}
            onChange={(event) => handleSearchColumnFn(event, 'companyName')}
          />
        </span>
      ),
      width: 220,
      align: 'center',
      dataIndex: 'companyName',
    },
    {
      title: 'Ghi Chú',
      width: 150,
      align: 'center',
      dataIndex: 'note',
    },
    {
      title: '#',
      fixed: 'right',
      align: 'center',
      width: 75,
      render: (record) => (
        <Popconfirm
          onConfirm={() => deletedSupplierMaterial(record)}
          title='Xoá NCC này？'
          okText='Yes'
          cancelText='No'
        >
          <a href='#'>Xoá</a>
        </Popconfirm>
      ),
    },
  ];

  const createSupplierMaterial = async () => {
    await setTitleTab('');
    await setFieldsForm({})
      .then((res) => getUpdatedSupplierMaterialForm(res, true))
      .then(() => setSelected({ isNew: true }));
    await setIsLoadingTab(false);
  };

  const headerContent = (
    <>
      <Button type='primary' onClick={createSupplierMaterial}>
        Thêm Mới
      </Button>
      <Input.Search
        style={{ width: '200px' }}
        className='mg-l-15'
        placeholder='Search'
        value={searchTerm}
        onChange={handleSearchTermChange}
      />
    </>
  );
  return (
    <TableLayout
      rowKey='id'
      columns={columns}
      data={supplierMaterial}
      loading={loading}
      selected={selected}
      closeDrawer={() => setSelected(null)}
      isLoadingTab={isLoadingTab}
      headerContent={headerContent}
      titleTab={titleTab}
      tabPanels={tabPanels}
      pagination={pagination}
      isDisplayCheckbox={false}
      headerLength='190px'
    />
  );
};

export { SupplierMaterial };
